<template>
  <b-modal v-model="visible" title="Cập nhật thông tin giao hàng" hide-footer centered size="lg">
    <ValidationObserver ref="observer">
      <form slot-scope="{ handleSubmit }" @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <b-col cols="7">
            <ValidationProvider
              name="hình thức giao hàng"
              rules="required"
              v-slot="{ errors, validate }"
            >
              <b-form-group>
                <label>Hình thức giao hàng <span style="color: red">*</span></label>
                <Select2
                  v-model="form.feeType"
                  :options="deliveryTypes"
                  @change="handleChangeFeeType($event)"
                  placeholder="Chọn hình thức giao hàng"
                  @close="validate()"
                  :disabled="!flagSetData && readOnly"
                >
                </Select2>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              name="đơn vị vận chuyển"
              :rules="{ required: isOnlineValidate }"
              v-slot="{ errors, validate }"
            >
              <b-form-group>
                <label
                  >Đơn vị vận chuyển
                  <span v-show="isOnlineValidate" style="color: red">*</span></label
                >
                <Select2
                  v-model="form.carrierName"
                  :options="Config.listCarrierName"
                  placeholder="Chọn đơn vị vận chuyển"
                  @close="validate()"
                  :disabled="isOnlineDisabled"
                >
                </Select2>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              name="Serial thiết bị gửi MC"
              rules="required"
              v-slot="{ errors, validate }"
            >
              <b-form-group>
                <label
                  >Serial thiết bị gửi MC
                  <span v-show="!(readOnly || flagSetData)" style="color: red">*</span></label
                >
                <SearchMultiChoice
                  ref="searchAutoCompleteRef"
                  v-model="form.deviceSerialsSent"
                  :list="listDevices"
                  placeholder="Chọn serial thiết bị"
                  labelKey="serial"
                  @close="validate()"
                  class="option-input"
                  :class="{ locked: readOnly || flagSetData }"
                />
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider :rules="{ required: isOnlineValidate }" name="Mã vận đơn">
              <b-form-group slot-scope="{ errors }">
                <label
                  >Mã vận đơn <span v-show="isOnlineValidate" style="color: red">*</span></label
                >
                <b-form-input
                  placeholder="Nhập mã vận đơn"
                  type="text"
                  v-model="form.trackingCode"
                  :state="errors[0] ? false : null"
                  :disabled="isOnlineDisabled"
                ></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Giá tiền vận chuyển">
              <b-form-group slot-scope="{ errors }">
                <label
                  >Giá tiền vận chuyển
                  <span v-show="isOnlineValidate" style="color: red">*</span></label
                >
                <b-form-input
                  :disabled="isOnlineDisabled"
                  type="text"
                  v-only-number-int-unsigned
                  @input="formatMoney"
                  v-model="form.fee"
                  :state="errors[0] ? false : null"
                ></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-form-group label="Ghi chú:" label-for="note">
              <b-form-input v-model="form.note" :disabled="!flagSetData && readOnly"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="5">
            <div class="upload-container">
              <UploadMultiple2
                :imagesPreview="form.imageUrls"
                title="Ảnh xác thực"
                :maxFile="100"
                titleTag="h2"
                :uploadToApi="false"
                :isDragging="true"
                titleClass="form-inner-heading"
                ref="uploadImages"
                :class="{ locked: !flagSetData && readOnly }"
              />
            </div>
          </b-col>
        </b-row>

        <!-- Footer -->
        <div class="d-flex justify-content-end mt-4">
          <b-button variant="outline-danger" class="mr-2" @click="closeModal" :disabled="isLoading">
            <b-icon icon="x" scale="2" aria-hidden="true" />
            Thoát
          </b-button>
          <b-button
            variant="outline-primary"
            @click="onSubmit"
            :disabled="isLoading || (!flagSetData && readOnly)"
          >
            <b-spinner small v-show="isLoading" />
            <b-icon icon="check" scale="2" aria-hidden="true" v-show="!isLoading" />
            Xác nhận
          </b-button>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import UploadMultiple2 from '@/components/cskh/UploadMultiple2.vue'
  import SearchMultiChoice from './SearchMultiChoice.vue'
  import { showMessSuccess, showMessErrorResponse, showMessError } from '@/config/utils'
  import { extend } from 'vee-validate'
  import { required, numeric, min_value } from 'vee-validate/dist/rules'
  import { LeadsService } from '@/services/lead.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  // Đăng ký rules
  extend('required', {
    ...required,
    message: '{_field_} không được để trống',
  })
  extend('numeric', {
    ...numeric,
    message: '{_field_} phải là số',
  })
  extend('min_value', {
    ...min_value,
    message: '{_field_} phải lớn hơn hoặc bằng {min}',
  })

  export default {
    components: {
      UploadMultiple2,
      SearchMultiChoice,
    },
    data() {
      return {
        Config,
        visible: false,
        isLoading: false,
        shippingLeadId: '',
        leadId: '',
        form: {
          feeType: '',
          carrierName: '',
          deviceSerialsSent: [],
          trackingCode: '',
          fee: 0,
          note: '',
        },
        deliveryArea: '',
        deliveryTypes: [
          { id: 'OFFLINE', text: 'Offline' },
          { id: 'ONLINE', text: 'Online' },
        ],
        listDevices: [],
        shippingStatus: null,
        flagSetData: false,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      readOnly() {
        return this.shippingStatus !== 'NEW'
      },
      isOnlineValidate() {
        return this.form.feeType === 'ONLINE'
      },
      isOnlineDisabled() {
        return this.form.feeType === 'OFFLINE' || (!this.flagSetData && this.readOnly)
      },
    },
    methods: {
      formatMoneyValue(val) {
        const numeric = String(val ?? '').replace(/\D/g, '')
        if (!numeric) return ''
        return Number(numeric).toLocaleString('vi-VI')
      },
      formatMoney(val) {
        this.form.fee = this.formatMoneyValue(val)
      },
      handleChangeFeeType(value) {
        const fee = this.deliveryArea === 'INNER_CITY' ? 100000 : 200000
        this.form.fee = value === 'ONLINE' ? '' : this.formatMoneyValue(fee)
        this.form.carrierName = ''
        this.form.trackingCode = ''
      },
      closeModal() {
        this.visible = false
        this.flagSetData = false
        this.resetForm()
      },
      async openModal(agentId = false, leadId = false) {
        this.visible = true
        if (this.flagSetData) return
        if (leadId) {
          const dataShipping = await this.fetchDataShipping(leadId)
          if (agentId && !this.readOnly) {
            await this.fetchDeviceByAgentId(agentId, dataShipping.id, dataShipping.leadId)
          }
        }
      },
      setDataForm(value) {
        this.flagSetData = true
        this.leadId = value.leadId
        this.shippingLeadId = value.id
        this.shippingStatus = value.shippingStatus
        this.deliveryArea = value.deliveryArea
        this.form = this.mapDataShipping(value)
      },
      resetForm() {
        this.form = {
          feeType: '',
          carrierName: '',
          deviceSerialsSent: [],
          trackingCode: '',
          fee: 0,
          note: '',
        }
        this.$refs.observer.reset()
      },
      mapDataShipping(data) {
        return {
          feeType: data.feeType,
          carrierName: data.carrierName,
          deviceSerialsSent: (data.devices || []).map(item => ({
            id: item.id,
            serial: item.serial,
            deviceName: item.deviceName,
            deviceCode: item.deviceCode,
          })),
          imageUrls: (data.imageUrls || []).map((item, idx) => ({
            id: idx,
            url: item,
          })),
          trackingCode: data.trackingCode,
          fee: this.formatMoneyValue(data.fee),
          notes: data.notes,
        }
      },
      async fetchDataShipping(leadId) {
        try {
          this.isLoading = true
          const response = await LeadsService.getDetailShippingInfor({ leadId })
          if (response.code === 1000) {
            this.form = this.mapDataShipping(response.data)
            this.leadId = response.data.leadId
            this.shippingLeadId = response.data.id
            this.deliveryArea = response.data.deliveryArea
            this.shippingStatus = response.data.shippingStatus
            return response.data
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        } finally {
          this.isLoading = false
        }
      },
      async fetchDeviceByAgentId(agentId, leadShippingId, leadId) {
        try {
          this.isLoading = true
          const params = {
            agentId,
            leadShippingId,
            leadId,
          }
          const response = await LeadsService.getDeviceByAgentId(params)
          if (response.code === 1000) {
            this.listDevices = response.data.map(item => ({
              id: item.id,
              serial: item.serial,
              deviceName: item.categoryName,
              deviceCode: item.abbreviation,
            }))
            this.$refs.searchAutoCompleteRef.setFilteredList(this.listDevices)
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        } finally {
          this.isLoading = false
        }
      },
      async onSubmit() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        try {
          this.isLoading = true
          const uploadedImages = await this.$refs.uploadImages.saveData()
          const existingImages = (this.form.imageUrls || [])
            .map(img => img.url || img)
            .filter(url => !uploadedImages.includes(url))
          const allImages = [...existingImages, ...uploadedImages]
          const { deviceSerialsSent, fee, ...res } = this.form
          const numericFee = Number(String(fee).replace(/[^\d]/g, ''))

          const payload = {
            ...res,
            imageUrls: allImages,
            leadId: this.leadId,
            shippingLeadId: this.shippingLeadId,
            fee: numericFee,
          }
          if (!this.flagSetData) {
            payload.deviceSerialsSent = deviceSerialsSent
          }
          const func = this.flagSetData
            ? LeadsService.updateInforShipppingByManagementTele
            : LeadsService.updateInforShippping
          const response = await func.bind(LeadsService)(payload)
          if (response.code === 1000) {
            showMessSuccess(this, 'Cập nhật thông tin đơn hàng thành công')
            this.$emit('change')
            this.closeModal()
          } else {
            this.showFailMx(response.message)
          }
        } catch (e) {
          this.showFailMx(e.message ?? e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .upload-container {
    height: 100%;
    padding: 1rem;
    border-left: 1px solid #dee2e6;
  }
  .locked {
    pointer-events: none;
  }
  .locked.option-input {
    background-color: #e2e7ed;
  }
</style>
